/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class HorseActivityPhotoRequest {
    'activity': number;
    'name'?: string;
    'image'?: HttpFile;
    'isMap'?: boolean;
    'isPremiumMap'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "activity",
            "baseName": "activity",
            "type": "number",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "image",
            "baseName": "image",
            "type": "HttpFile",
            "format": "binary"
        },
        {
            "name": "isMap",
            "baseName": "isMap",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isPremiumMap",
            "baseName": "isPremiumMap",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return HorseActivityPhotoRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

